import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";

interface Props {
  checklistType: server.dto.ChecklistTypes
  isOpen: boolean
  onClose: () => void
  onCreated: () => void
}

export const NewChecklistItemModal = (props: Props) => {
  const [question, setQuestion] = React.useState<string>("");

  const onClose = () => {
    setQuestion("");
    props.onClose();
  }

  const submit = () => {
    return window.CoreApi.ChecklistPreset.CreateChecklistPresetItem({
      checklistType: props.checklistType,
      question,
    });
  }

  const onSuccess = async () => {
    onClose();
    props.onCreated();
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Buttons.btnNew}
    handleClose={onClose}
    width="tiny"
  >
    <EditSectionTemplate
      submit={submit}
      noPanels
      onSuccess={onSuccess}
      sections={[{
        key: "newChecklistPresetItem",
        type: "regular",
        title: RESX.Buttons.btnNew,
        fields: [{
          key: "position",
          label: RESX.GeneralLabels.Label,
          renderEditNew: () => (
            <RequiredTextInput
              focusOnMount
              maxLength={serverReference.constants.checklist.maxQuestionLength}
              value={question}
              onChange={(value) => setQuestion(value)}
              validatorKey="question"
            />
          )
        }]
      }]}
    />
  </Modal>
}

